import { Box, Typography } from '@mui/material';
import { styles } from './Questionnaire.styles';
import { useFormContext, useFormState } from 'react-hook-form';
import { SelectButton } from './SelectButton';

type SelectBooleanProps = {
  name: string;
};

export const SelectBoolean = ({ name }: SelectBooleanProps) => {
  const { setValue, watch } = useFormContext();
  const { errors } = useFormState({ name });

  const value = watch(name);

  const errorMessage: any = !!errors[name]?.message
    ? errors[name]?.message
    : '';

  const isError = !!errorMessage;

  return (
    <Box>
      {!!isError && (
        <Typography sx={{ marginBottom: '10px', color: 'red' }}>
          {errorMessage}
        </Typography>
      )}
      <Box sx={styles.booleanWrapper}>
        <SelectButton selected={!!value} onClick={() => setValue(name, true)}>
          Yes
        </SelectButton>
        <SelectButton
          selected={value === undefined ? false : !value}
          onClick={() => setValue(name, false)}
        >
          No
        </SelectButton>
      </Box>
    </Box>
  );
};
